import type { LanguageType } from "fansunited-frontend-core";

/**
 * Map our 13 canvas locale codes to the library's LanguageType.
 * Locales the library doesn't natively support (th, vi, zh, ko) fall back
 * to "en". pt-BR is normalised to the library's lowercase "pt-br".
 */
export function mapLocaleToLibraryLanguage(locale: string): LanguageType {
    const normalised = locale.toLowerCase();
    const supported = [
        "ar", "bg", "en", "ro", "pt", "sr", "fr", "de", "it", "fr-be", "pl", "pt-br", "sk", "es", "el",
    ] as string[];
    if (supported.includes(normalised)) {
        return normalised as LanguageType;
    }
    return "en";
}
